/* eslint-disable import/no-internal-modules */
import { CartIconButtonSideBarV2 } from "user_site/features/cart";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <CartIconButtonSideBarV2 />
  </WithProviders>
);

export default Component;
